/**
 * VideoCallPageWrapper - Wrapper pour choisir entre Agora et P2P
 * Par défaut : Agora (interface existante)
 * Avec ?mode=p2p : WebRTC P2P (nouvelle interface)
 */
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import VideoCallPage from './VideoCallPage';
import VideoCallPageP2P from './VideoCallPageP2P';

const VideoCallPageWrapper = () => {
  const location = useLocation();
  const [mode, setMode] = useState('agora'); // 'agora' par défaut

  useEffect(() => {
    // Extraire le paramètre mode de l'URL
    const searchParams = new URLSearchParams(location.search);
    const urlMode = searchParams.get('mode');
    
    // Seulement utiliser P2P si explicitement demandé via ?mode=p2p
    if (urlMode === 'p2p') {
      setMode('p2p');
    } else {
      // Par défaut, toujours utiliser Agora (interface existante)
      setMode('agora');
    }
  }, [location.search]);

  // Si mode P2P explicitement demandé, afficher le composant P2P
  if (mode === 'p2p') {
    return <VideoCallPageP2P />;
  }

  // Par défaut, toujours afficher Agora (interface existante)
  return <VideoCallPage />;
};

export default VideoCallPageWrapper;

